import { NavigationTab } from 'shared/model';

import { AddCarModelButtonLink } from './buttons';

export const TABS: Array<NavigationTab> = [
  {
    key: 'edit-car-brand',
    label: 'Редактирование марки',
    path: '',
  },
  {
    key: 'car-models',
    label: 'Список моделей',
    path: 'models',
    buttons: [
      {
        element: <AddCarModelButtonLink />,
        controller: 'Car',
        right: 'Write',
      },
    ],
  },
];
